import { DatePipe, TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from 'src/app/translations/locale.service';
import { isNullOrUndefined } from '../util/helper.util';

@Pipe({
  name: 'localeDate',
  pure: false // important: updates on change
})
export class LocaleDatePipe implements PipeTransform {
  constructor(private localeService: LocaleService, private titleCasePipe: TitleCasePipe) {}

  transform(value: any = undefined, format: string = 'mediumDate'): string | null {
    if (isNullOrUndefined(value)) {
      return null;
    }
    const transformedDate = this.transformDate(value, format, this.localeService.currentLocale);
    return transformedDate ? transformedDate : this.transformDate(value, format, 'en-US');
  }

  transformDate(value: any, format: string = 'mediumDate', locale: string) {
    try {
      const datePipe = new DatePipe(locale);
      const transformedDate = datePipe.transform(value, format);

      // Only apply title case if we have a valid transformed date
      return transformedDate ? this.titleCasePipe.transform(transformedDate) : null;
    } catch (error) {
      console.error('Error transforming date:', error);
      return null;
    }
  }
}
